import { userSelectedMarketUpdate } from '@/features/selectedMarket/selectedMarketSlice';
import MarketListItem from '@/shared/components/MarketListItem/MarketListItem';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { IonGrid, IonItem } from '@ionic/react';
import { EntityId } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import styles from './MarketList.module.css';
import React from 'react';
import { useGetMarketInfoQuery } from '@/features/marketInfo/marketInfoApi';

type Props = {
  selectedMarket?: EntityId;
};

const MarketList: React.FC<Props> = ({ selectedMarket }) => {
  const dispatch = useDispatch();
  const { isMobileView } = useWindowDimensions();

  const { data: marketInfo } = useGetMarketInfoQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: 10 * 1000 // every 10s
  });

  return (
    <>
      {marketInfo &&
        marketInfo.ids.map((id) => {
          const market = marketInfo.entities[id];
          if (!market) {
            return null;
          }
          return (
            <IonItem
              lines="none"
              className={`ion-no-padding ${styles.listWrapper} ${
                isMobileView ? styles.itemWrapperMobile : styles.itemWrapper
              } ${selectedMarket === market.id && !isMobileView ? styles.itemActive : ''}`}
              key={market.id}
              routerLink={`/markets/${market.id}?detail`}
              onClick={(event: any) => {
                const market = marketInfo.ids.find((id) => event.target.href.includes(id));
                if (market && marketInfo.entities[market]) {
                  dispatch(
                    userSelectedMarketUpdate({
                      id: 1,
                      changes: {
                        id: 1,
                        market
                      }
                    })
                  );
                }
              }}
            >
              <IonGrid className={`${styles.itemContainer}`}>
                <MarketListItem market={market} />
              </IonGrid>
            </IonItem>
          );
        })}
    </>
  );
};

export default MarketList;
